module.exports = __webpack_public_path__ + "static/media/08_360.bcad512e.jpeg";